import { TruncatedText } from "@spz/ui/components/truncated-text";
import { cn } from "@spz/ui/lib/utils";
import type { TextCellProps } from "../types";

export const TextCell: React.FC<TextCellProps> = ({
  value,
  maxLines = 2,
  className,
  showTooltip = true,
  onClick,
}) => {
  const content = (
    <span
      className={cn(
        "text-body font-base capitalize",
        onClick
          ? "cursor-pointer hover:underline hover:text-blue-800"
          : "cursor-default",
        "whitespace-normal break-words overflow-hidden",
        className,
      )}
      onClick={(e) => {
        if (onClick) {
          e.stopPropagation();
          onClick();
        }
      }}
      onKeyDown={(e) => {
        if (onClick && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          e.stopPropagation();
          onClick();
        }
      }}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {value}
    </span>
  );

  return showTooltip ? (
    <TruncatedText maxLines={maxLines}>{content}</TruncatedText>
  ) : (
    content
  );
};
